module.exports = __webpack_public_path__ + "img/UNIONPAY.png?f6d85fb97226b365401276b9f99d9db6";